import SettingsLandingPage from '../../components/SettingsLandingPage';

const Settings = () => {
  return <SettingsLandingPage checkpointsPath="/settings/checkpoints" />;
};

export default Settings;
